var redirect_url_brainacademy = $('.temp_information').data(
  'redirect-url-brainacademy',
);
var is_success_page = $('.temp_information').data('is-success-page');
if (
  redirect_url_brainacademy !== '' &&
  redirect_url_brainacademy !== undefined &&
  is_success_page === true
) {
  setTimeout(function() {
    window.location = redirect_url_brainacademy;
  }, 3000);
}
